import * as React from "react";
const Heart = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 96, height: 96, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95.5.5H.5v95h95z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#CFCFCF", d: "M48 13.1C37.3 2.4 19.8 2.4 9.1 13.1-1.6 23.9-1.6 41.3 9.1 52L48 90.9 86.9 52z" }),
        React.createElement("path", { fill: "#ED0000", d: "M86.9 13.1 67.5 32.6 48 13.1c10.7-10.7 28.2-10.7 38.9 0" }),
        React.createElement("path", { fill: "#3F3F3F", d: "M86.9 52 67.5 32.6 87 13.1c10.6 10.8 10.6 28.2-.1 38.9" }))));
export default Heart;
//# sourceMappingURL=Heart.js.map